<template>
    <div class="store-product-list">
        <div class="product" v-for="product in products" :key="product.id">
            <product-image :product="product.data"/>
            <storeProductAdd :product="product"/>
        </div>
    </div>
</template>

<script>
import storeProductAdd from "./storeProductAdd";
import db from '@/services/database';
import ProductImage from "@/modules/products/components/ProductImage";

export default {
    name: "storeProductList",
    components: {
        ProductImage,
        storeProductAdd
    },

    data() {
        return {
            products: []
        }
    },

    created() {

        let loading = this.$buefy.loading.open();

        this._unsubscriveProductsSnapshots = db.collection('products')
            .where('active', '==', true)
            .orderBy('name')
            .onSnapshot((spapshot) => {
                const products = []
                spapshot.forEach(document => {
                    products.push({
                        id: document.id,
                        data: document.data()
                    });
                });

                this.products = products;

                if (loading) {
                    loading.close();
                }
            })
    },
}
</script>

<style lang="scss">
@import "@/styles/config.sass";

.store-product-list {
    .product {
        padding: $conf-espaco-pequeno 0;
        display: flex;
        align-items: center;

        .product-image {
            width: 65px;
        }

        .add-products-to-cart {
            flex: 1 auto;
        }

        &:not(:last-child) {
            border-bottom: 1px solid $border;
        }
    }
}
</style>